import { render } from "./BrandsListLoader.vue?vue&type=template&id=19681c3b&scoped=true"
import script from "./BrandsListLoader.vue?vue&type=script&lang=js"
export * from "./BrandsListLoader.vue?vue&type=script&lang=js"

import "./BrandsListLoader.vue?vue&type=style&index=0&id=19681c3b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19681c3b"]])

export default __exports__